module.exports = __webpack_public_path__ + "static/img/TORONTO_PAINT.7ecdc6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/TORONTO_PAINT.jpg
// module id = aqHg
// module chunks = 0